module.exports = __webpack_public_path__ + "img/5.6711d208.png";